// @flow

import { call, fork, put, take } from 'redux-saga/effects'
import { GET_LEAGUES_STATUSES, getLeaguesStatuses } from 'src/redux/actions/leagues/leagues'
import http from 'src/services/http'

// types
import type { IOEffect } from 'redux-saga/effects'

function * watchGetLeaguesStatuses(): Generator<IOEffect, void, any> {
  while (true) {
    yield take(GET_LEAGUES_STATUSES.REQUEST)

    try {
      const data = yield call(http, 'admin/league-statuses', {
        method: 'GET',
      })

      yield put(getLeaguesStatuses.success(data.data))
    } catch (e) {
      yield put(getLeaguesStatuses.error(e.message))
    }
  }
}

export default [fork(watchGetLeaguesStatuses)]
